export default __webpack_public_path__ + "static/media/gavel.969ecf62.png";